"use client";

import LayoutWrapper from "@/components/layout/wrapper";
import VideosList from "./videos-accordion-component";
import { VideoTutorialSchema } from "@/types/video-tutorials";
import Breadcrumb from "@/components/bread-crumb";
import QuerySearchInput from "@/components/search/query-search-input";

export default function VideoTutorials({ tutorials }: Readonly<{
  tutorials: VideoTutorialSchema[],
}>) {
  return (
    <LayoutWrapper className="py-5 pb-10 lg:w-240">
      <Breadcrumb
        items={[
          {
            title: "خانه",
            route: "/",
          },
          {
            title: "آموزش‌ها",
          },
          {
            title: "آموزش‌های ویدئویی",
          },
        ]}
      />
      <h1 className="text-4xl mb-10 text-center mt-8">آموزش‌های ویدئویی <strong className="text-primary">مشاور</strong></h1>
      <p className="text-description leading-7 text-center mb-8">
        در هنگام کار با سی آر ام مشاور، با نقش های مختلفی روبه‌رو خواهيد شد. در این صفحه ما به معرفی ويدئویی هر نقش پرداخته ایم.
        <br />
        به‌علاوه، با كليك بر روى مشاهده آموزش هاى هر بخش نيز مى توانيد به ويدئوهای تهیه شده برای آن نقش دسترسی داشته باشید.
      </p>

      <QuerySearchInput />

      <section className="w-full mt-10">
        {
          tutorials?.map(role => {
            if (role?.section_id) {
              return (
                <VideosList
                  key={role?.section_id}
                  headerTitle={`نقش: ${role?.section_role}`}
                  videos={role?.educations}
                  sectionId={role?.section_id}
                  showBySubsections
                />
              )
            }
          })
        }
      </section>
    </LayoutWrapper>
  );
};